export const formatListChanges = (added, removed) => {
  if (added && removed) return `${added.toLocaleString("en-US")} added, ${removed.toLocaleString("en-US")} removed`;
  if (added) return `${added.toLocaleString("en-US")} added`;
  if (removed) return `${removed.toLocaleString("en-US")} removed`;
  return "";
};
